import * as Yup from "yup";
import { GeneralFieldController } from "./general-field-controller";

export class AdministrationDateFieldController extends GeneralFieldController {
	override createValidationRule(initialData: unknown, translation: (key: string) => string): Yup.AnySchema {
		return (super.createFieldValidationRuleByDataType(translation) as Yup.DateSchema)
			.nullable()
			.required()
			.max(new Date(), translation("cannot-be-greater-than-today"));
	}

	override useControlProps(path: string) {
		return {
			cannotBeFuture: true,
		};
	}
}
